import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import Cards from './Card/Cards';
import styles from './index.module.scss';

export type PartnerBenefitsProps =
  SliceComponentProps<Content.PartnerBenefitsSlice>;

const PartnerBenefits = ({ slice }: PartnerBenefitsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      <div className={styles.titleWrapper}>
        <div className={styles.title}>
          <PrismicRichText field={slice.primary.title} />
        </div>
        <p className={styles.subtitle}>{slice.primary.subtitle}</p>
      </div>
      <Cards cards={slice.primary.cards} />
    </section>
  );
};

export default PartnerBenefits;
